import { useCallback, useMemo } from 'react';

import { FCC } from '@eluve/components';
import { useNamedLogger } from '@eluve/logger';
import { FeatureFlagKeys, featureFlagsWithPayloads } from '@eluve/posthog';

import { useAnalytics } from './useAnalytics';
import {
  FeatureFlagContextType,
  FeatureFlagProvider as Provider,
} from './useFeatureFlagPayload';

export const FeatureFlagProvider: FCC = ({ children }) => {
  const logger = useNamedLogger('FeatureFlagProvider');
  const analytics = useAnalytics();

  const getFeatureFlagData = useCallback(
    (flagKey: FeatureFlagKeys) => {
      return analytics.getFeatureFlagPayload(flagKey);
    },
    [analytics],
  );

  const contextData: FeatureFlagContextType = useMemo(() => {
    return {
      flagDefinitions: featureFlagsWithPayloads,
      getFeatureFlagData,
      logger,
    };
  }, [getFeatureFlagData, logger]);

  return <Provider value={contextData}>{children}</Provider>;
};
